import http from "../../utils/http";
export const getSi4nHealthInsurance = (params = {
  mgmtNo: null,
  yyyyMM: null
}) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/si4n/health-insurance`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};